module.exports = __webpack_public_path__ + "static/media/logo.90afb9d7.png";